import {
  AltiusRes,
  DealBase,
  DownloadFileReq,
  ICreateTaskReq,
  IUpdateStatusReq,
  IUpdateTaskReq,
  IUser,
  Task,
  TaskCreate,
  TaskPreview,
  TaskQueries,
  TaskQueryParams
  // UserLight
} from "store/types";
import rmEmptyFields from "utils/rm-empty-fields";
import { TaskManageAction } from "..";
import { AsyncActions, AsyncActionsParams } from "../base";
import { toFormData } from "utils";
import downloadFileAxios from "utils/download-file-axios";

export interface ITaskManageActions {
  getTasksAction: (data: TaskQueries) => Promise<void>;
  getTaskAction: (id: number) => Promise<Task>;
  createTaskAction: (data: ICreateTaskReq) => Promise<void>;
  updateTaskAction: (data: IUpdateTaskReq) => Promise<void>;
  updateTaskStatusAction: (data: IUpdateStatusReq) => Promise<void>;
  deleteTaskAction: (id: number) => Promise<void>;
  setCreateAction: (data: TaskCreate) => void;
  clearTasksAction: () => void;
  getDealsAction: () => Promise<void>;
  downloadFileAction: (data: DownloadFileReq) => Promise<void>;
}

interface TaskManageActionsParams extends AsyncActionsParams {
  user: IUser;
}

export class TaskManageActions extends AsyncActions implements ITaskManageActions {
  protected readonly user: IUser;
  public constructor({ user, ...params }: TaskManageActionsParams) {
    super(params);
    this.user = user;
  }

  private queriesToParams = (queries: TaskQueries): TaskQueryParams => {
    let params: TaskQueryParams = {};
    const { id: userId } = this.user;
    const {
      isMyOpen,
      insideDeal,
      // isMyRecurring,
      status,
      due_date,
      priority,
      deal,
      assignee,
      ...rest
    } = queries;

    if (isMyOpen) {
      // Add deal to specific filter if inside the deal
      if (insideDeal && deal.length) {
        params.deal_ids = deal.map((item) => item.id);
      }

      params.assignee_ids = [userId];
      params.statuses = ["in-progress", "open"];
      return params;
    }

    // if (isMyRecurring) {
    //   params.assignee_id = userId;
    //   params.creator_id = userId;
    //   return params;
    // }

    const clearedRest = rmEmptyFields(rest);
    params = { ...clearedRest };
    if (status.length) {
      params.statuses = status.map((item) => item.value);
    }

    if (due_date.length) {
      params.due_dates = due_date.map((item) => item.value);
    }

    if (priority) {
      params.priority = priority.value;
    }

    if (deal.length) {
      params.deal_ids = deal.map((item) => item.id);
    }

    if (assignee.length) {
      params.assignee_ids = assignee.map((item) => item.id);
    }

    return params;
  };

  public getTasksAction = async (queries: TaskQueries): Promise<void> => {
    const params = this.queriesToParams(queries);
    const {
      data: { data: payload }
    } = await this.api.get<AltiusRes<TaskPreview[]>>({
      url: "/api/v0.0.3/tasks",
      params
    });
    this.dispatch({
      type: TaskManageAction.GetTasksSuccess,
      // payload: mockTasks,
      payload
    });
  };

  public getTaskAction = async (id: number): Promise<Task> => {
    const {
      data: { data }
    } = await this.api.get<AltiusRes<Task>>({
      url: `/api/v0.0.3/tasks/${id}`
    });
    return data;
    // this.dispatch({ type: TaskManageAction.GetTaskSuccess, payload: data });
  };

  public createTaskAction = async (body: ICreateTaskReq): Promise<void> => {
    const {
      data: { data: payload }
    } = await this.api.post<AltiusRes<TaskPreview>>({
      url: "/api/v0.0.3/tasks",
      data: toFormData({
        ...body
      }),
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
    this.dispatch({ type: TaskManageAction.CreateTaskSuccess, payload });
  };

  public updateTaskStatusAction = async ({ id, ...body }: IUpdateStatusReq): Promise<void> => {
    const {
      data: { data }
    } = await this.api.post<AltiusRes<TaskPreview>>({
      url: `/api/v0.0.3/tasks/${id}/status`,
      data: toFormData({
        _method: "PATCH",
        ...body
      }),
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
    this.dispatch({
      type: TaskManageAction.UpdateTaskSuccess,
      payload: data
    });
  };

  public updateTaskAction = async ({ id, ...body }: IUpdateTaskReq): Promise<void> => {
    const {
      data: { data }
    } = await this.api.post<AltiusRes<TaskPreview>>({
      url: `/api/v0.0.3/tasks/${id}`,
      data: toFormData({
        _method: "PATCH",
        ...body
      }),
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
    this.dispatch({
      type: TaskManageAction.UpdateTaskSuccess,
      payload: data
    });
  };

  public deleteTaskAction = async (id: number) => {
    await this.api.delete({ url: `/api/v0.0.3/tasks/${id}` });
    this.dispatch({ type: TaskManageAction.DeleteTaskSuccess, payload: id });
  };

  public setCreateAction = (payload: TaskCreate): void => {
    this.dispatch({ type: TaskManageAction.SetCreate, payload });
  };

  public clearTasksAction = async () => {
    this.dispatch({ type: TaskManageAction.ClearTasks, payload: null });
  };

  public getDealsAction = async () => {
    const {
      data: { data }
    } = await this.api.post<AltiusRes<DealBase[]>>({
      url: "/api/v0.0.2/deals-list",
      data: { view: "task-manage" }
    });
    this.dispatch({ type: TaskManageAction.GetDealsSuccess, payload: data });
  };

  public downloadFileAction = async (data: DownloadFileReq): Promise<void> => {
    const { fileId, taskId } = data;
    // Get Response from API
    return this.api
      .get({
        url: `/api/v0.0.3/tasks/${taskId}/files/${fileId}`,
        responseType: "blob"
      })
      .then(downloadFileAxios);
  };
}
